export default "__VITE_ASSET__emKih9yr__"